import { Divider, Stack, Typography } from '@mui/material';
import React from 'react';

import { ConversionByVersion, PopulationData } from './components';

const BsimmTab: React.FC = () => {
  return (
    <Stack>
      <Stack>
        <Typography variant='subtitle1' color='textPrimary'>
          BSIMM Conversion by Version
        </Typography>
        <ConversionByVersion />
      </Stack>

      <Divider />

      <Stack>
        <Typography variant='subtitle1' color='textPrimary'>
          Population Data Upload
        </Typography>
        <PopulationData />
      </Stack>
    </Stack>
  )
}

export default BsimmTab;